import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import Sidebar from '../Sidebar/Sidebar';
import useGlobalContext from '../../hooks/useGlobalContext';
import { ArrowUpRight, Bug, CalendarCog, FileSpreadsheet, MessageCircleQuestion, Newspaper, PaintBucket, LayoutGrid, Terminal, Sparkles, Database, TrendingUp, Landmark, UtensilsCrossed, GraduationCap } from 'lucide-react';

const NavHeader = () => {
   const [show, setShow] = useState(false);
   const handleClose = () => setShow(false);
   const handleShow = () => setShow(true);
   const { stickyMenu, hideHeader } = useGlobalContext();
   return (
      <>
         <header>
            <div className="header__area p-relative header__transparent">
               <div id="header__sticky" className={`${stickyMenu ? 'sticky header__bottom header__bottom-2' : 'header__bottom header__bottom-2'}${hideHeader ? ' header__bottom--hidden' : ''}`}>
                  <div className="tw-container tw-mx-auto">
                     <div className="tw-flex tw-flex-wrap tw--mx-3 tw-items-center">
                        <div className="tw-w-1/2 tw-px-3 lg:tw-w-1/4">
                           <div className="logo">
                              <NavLink to="/">
                                 <img src="/assets/img/logo/Harsoft_Logo_White_png.png" alt="logo" />
                              </NavLink>
                           </div>
                           <div className="logo-gradient">
                              <NavLink to="/">
                                 <img src="/assets/img/logo/Harsoft_Logo_Color_png.png" alt="logo" />
                              </NavLink>
                           </div>
                        </div>
                        <div className="tw-w-1/2 tw-px-3 lg:tw-w-3/4">
                           <div className="header__bottom-right tw-flex tw-justify-end tw-items-center">
                              <div className="main-menu menu_wrapper_one">
                                 <nav id="mobile-menu">
                                    <ul className='tw-m-0 tw-p-0 flex-column'>
                                       <li><NavLink to="/ourStory">Our Story</NavLink></li>
                                       <li className=''>
                                          <NavLink to="/software-product-development">Offerings</NavLink>
                                          <ul className="submenu offerings-submenu">
                                             <li>
                                                <NavLink to="/software-product-development" className="tw-flex">
                                                   <div className='icon'><LayoutGrid size="36" strokeWidth='1' /></div>
                                                   <div className='text'>
                                                      <p>Software & Product Development</p>
                                                      <span>Crafting Seamless Digital Experiences</span>
                                                   </div>
                                                </NavLink>
                                             </li>
                                             <li>
                                                <NavLink to="/python-backend-development" className="tw-flex">
                                                   <div className='icon'><Terminal size="36" strokeWidth='1' /></div>
                                                   <div className='text'>
                                                      <p>Python & Backend Development</p>
                                                      <span>REST APIs, FastAPI & Django</span>
                                                   </div>
                                                </NavLink>
                                             </li>
                                             <li>
                                                <NavLink to="/ai-automation" className="tw-flex">
                                                   <div className='icon'><Sparkles size="36" strokeWidth='1' /></div>
                                                   <div className='text'>
                                                      <p>AI & Intelligent Automation</p>
                                                      <span>AI Agents, Chatbots & RAG</span>
                                                   </div>
                                                </NavLink>
                                             </li>
                                             <li>
                                                <NavLink to="/database-data-solutions" className="tw-flex">
                                                   <div className='icon'><Database size="36" strokeWidth='1' /></div>
                                                   <div className='text'>
                                                      <p>Database & Data Solutions</p>
                                                      <span>PostgreSQL, SQL & Data Migration</span>
                                                   </div>
                                                </NavLink>
                                             </li>
                                             <li>
                                                <NavLink to="/UIUX" className="tw-flex">
                                                   <div className='icon'><PaintBucket size="36" strokeWidth='1' /></div>
                                                   <div className='text'>
                                                      <p>UI/UX & Product Design</p>
                                                      <span>Research-Driven Design Systems</span>
                                                   </div>
                                                </NavLink>
                                             </li>
                                             <li>
                                                <NavLink to="/digital-marketing-seo" className="tw-flex">
                                                   <div className='icon'><TrendingUp size="36" strokeWidth='1' /></div>
                                                   <div className='text'>
                                                      <p>Digital Marketing & SEO</p>
                                                      <span>SEO, Google Ads & Lead Generation</span>
                                                   </div>
                                                </NavLink>
                                             </li>
                                             <li>
                                                <NavLink to="/CMSSolutions" className="tw-flex">
                                                   <div className='icon'><CalendarCog size="36" strokeWidth='1' /></div>
                                                   <div className='text'>
                                                      <p>CMS Solutions</p>
                                                      <span>Streamline Your Digital Presence</span>
                                                   </div>
                                                </NavLink>
                                             </li>
                                             <li>
                                                <NavLink to="/SoftwareTesting" className="tw-flex">
                                                   <div className='icon'><Bug size="36" strokeWidth='1' /></div>
                                                   <div className='text'>
                                                      <p>Software Testing</p>
                                                      <span>Ensuring Quality and Reliability</span>
                                                   </div>
                                                </NavLink>
                                             </li>
                                             <li>
                                                <NavLink to="/ITSupportManaged" className="tw-flex">
                                                   <div className='icon'><MessageCircleQuestion size="36" strokeWidth='1' /></div>
                                                   <div className='text'>
                                                      <p>IT Support & Managed</p>
                                                      <span>Digital Infrastructure Running Smoothly</span>
                                                   </div>
                                                </NavLink>
                                             </li>
                                          </ul>
                                       </li>
                                       <li className=''>
                                          <NavLink to="/industries/fintech">Industries</NavLink>
                                          {/* offerings-submenu */}
                                          <ul className="submenu">
                                             <li>
                                                <NavLink to="/industries/fintech" className="tw-flex">
                                                   <div className='icon'><Landmark size="36" strokeWidth='1' /></div>
                                                   <div className='text'>
                                                      <p>FinTech</p>
                                                      <span>Secure, Compliant Financial Software</span>
                                                   </div>
                                                </NavLink>
                                             </li>
                                             <li>
                                                <NavLink to="/industries/food-catering" className="tw-flex">
                                                   <div className='icon'><UtensilsCrossed size="36" strokeWidth='1' /></div>
                                                   <div className='text'>
                                                      <p>Food & Catering</p>
                                                      <span>Digital Ordering & Growth</span>
                                                   </div>
                                                </NavLink>
                                             </li>
                                             {/* <li>
                                                <NavLink to="/industries/agriculture" className="tw-flex">
                                                   <div className='icon'><Wheat size="36" strokeWidth='1' /></div>
                                                   <div className='text'>
                                                      <p>Agriculture</p>
                                                      <span>Data-Driven Farming Software</span>
                                                   </div>
                                                </NavLink>
                                             </li> */}
                                             <li>
                                                <NavLink to="/industries/education" className="tw-flex">
                                                   <div className='icon'><GraduationCap size="36" strokeWidth='1' /></div>
                                                   <div className='text'>
                                                      <p>Education</p>
                                                      <span>Platforms for Learning Organizations</span>
                                                   </div>
                                                </NavLink>
                                             </li>
                                             {/* <li>
                                                <NavLink to="/industries/healthcare" className="tw-flex">
                                                   <div className='icon'><HeartPulse size="36" strokeWidth='1' /></div>
                                                   <div className='text'>
                                                      <p>Healthcare</p>
                                                      <span>Reliable Healthcare Software</span>
                                                   </div>
                                                </NavLink>
                                             </li> */}
                                             {/* <li>
                                                <NavLink to="/industries/real-estate" className="tw-flex">
                                                   <div className='icon'><Building2 size="36" strokeWidth='1' /></div>
                                                   <div className='text'>
                                                      <p>Real Estate</p>
                                                      <span>Digital Tools for Real Estate</span>
                                                   </div>
                                                </NavLink>
                                             </li> */}
                                             {/* <li>
                                                <NavLink to="/industries/retail-ecommerce" className="tw-flex">
                                                   <div className='icon'><ShoppingCart size="36" strokeWidth='1' /></div>
                                                   <div className='text'>
                                                      <p>Retail & E-commerce</p>
                                                      <span>Software That Powers Sales</span>
                                                   </div>
                                                </NavLink>
                                             </li> */}
                                          </ul>
                                       </li>
                                       <li>
                                          <NavLink to="/blogs">Insights</NavLink>
                                          <ul className="submenu">
                                             <li>
                                                <NavLink to="/blogs" className="flex">
                                                   <div className='icon'><Newspaper size="36" strokeWidth='1' /></div>
                                                   <div className='text'>
                                                      <p>Blog</p>
                                                      <span>Discover, Learn and Thrive <br />with us</span>
                                                   </div>
                                                </NavLink>
                                             </li>

                                             <li>
                                                <NavLink to="/" end className="tw-flex">
                                                   <div className='icon'><FileSpreadsheet size="36" strokeWidth='1' /></div>
                                                   <div className='text'>
                                                      <p>Case Studies</p>
                                                      <span>Crafting Seamless Digital Experiences</span>
                                                   </div>
                                                </NavLink>
                                             </li>
                                          </ul>
                                       </li>
                                       <li>
                                          <NavLink to="/contact" className="btn-more">
                                             <span className="btn-text">Get in touch</span>
                                             <span className="btn-icon" aria-hidden="true">
                                                <ArrowUpRight size="16px" className="icon" />
                                             </span>
                                          </NavLink>
                                       </li>
                                    </ul>
                                 </nav>
                              </div>
                              <div onClick={handleShow} className="sidebar__menu tw-block lg:tw-hidden">
                                 <div className="sidebar-toggle-btn" id="sidebar-toggle">
                                    <span className="line"></span>
                                    <span className="line"></span>
                                    <span className="line"></span>
                                 </div>
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </header>


         <Sidebar show={show} handleClose={handleClose} />
      </>
   );
};

export default NavHeader;
